import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3202, { U3202ROLES } from './U3202';
import U3202OrgProviderConfigList from './components/U3202OrgProviderConfigList';
import U3202OrgProviderConfigForm from './components/U3202OrgProviderConfigForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3202Routes: RouteObject[] = [
  {
    path: 'U3202',
    element: <U2000RequireRole allowedRoles={[U3202ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3202 />,
        children: [
          { index: true, element: <U3202OrgProviderConfigList /> },
          { path: ':id', element: <U3202OrgProviderConfigForm /> },
        ],
      },
    ],
  },
];

export default U3202Routes;
